import React from "react";

import type { RootProps } from "./types";

import { RootElementContextProvider } from "./context";

export const Root = ({
  isScoresLoading,
  isMarkersLoading,
  scoresData,
  activeCategory,
  activeCategoryData,
  activeScore,
  activeScoreData,
  markersData,
  onSelectCategory,
  onSelectScore,
  children,
}: RootProps) => (
  <RootElementContextProvider
    isScoresLoading={isScoresLoading}
    isMarkersLoading={isMarkersLoading}
    scoresData={scoresData}
    activeCategory={activeCategory}
    activeCategoryData={activeCategoryData}
    activeScore={activeScore}
    activeScoreData={activeScoreData}
    markersData={markersData}
    onSelectCategory={onSelectCategory}
    onSelectScore={onSelectScore}
  >
    {children}
  </RootElementContextProvider>
);

// Export children
export { Toggle } from "./Toggle";
export { Content } from "./Content";
export { Category } from "./Category";
export { Slider } from "./Slider";
export { Score } from "./Score";
